'use client';

import { getSessionJSONItem, setSessionJSONItem } from '@/lib/utils';

export const APP_PROMO_DISMISSED_SESSION_KEY = 'app-promo-strip-dismissed';

const listeners = new Set<() => void>();

function subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

function getSnapshot(): boolean {
    return getSessionJSONItem<boolean>(APP_PROMO_DISMISSED_SESSION_KEY) === true;
}

/** No session storage on the server; the real value swaps in after hydration. */
function getServerSnapshot(): boolean {
    return false;
}

function dismiss(): void {
    setSessionJSONItem(APP_PROMO_DISMISSED_SESSION_KEY, true);
    listeners.forEach((listener) => listener());
}

export const appPromoDismissalStore = {
    subscribe,
    getSnapshot,
    getServerSnapshot,
    dismiss,
};
